// src/api/api.js
const API_BASE = process.env.REACT_APP_API_BASE || "/api";

export function getTokens() {
  return {
    access: localStorage.getItem("token"),
    refresh: localStorage.getItem("refresh_token"),
  };
}

export function setTokens({ access, refresh }) {
  if (access) localStorage.setItem("token", access);
  if (refresh) localStorage.setItem("refresh_token", refresh);
}

export function clearTokens() {
  localStorage.removeItem("token");
  localStorage.removeItem("refresh_token");
}

async function refreshTokens() {
  const { refresh } = getTokens();
  if (!refresh) throw new Error("No refresh token");

  const res = await fetch(`${API_BASE}/token/refresh`, {
    method: "POST",
    headers: { Authorization: `Bearer ${refresh}` },
  });

  if (!res.ok) throw new Error("Refresh failed");
  const data = await res.json();
  setTokens({ access: data.access_token, refresh: data.refresh_token });
  return data.access_token;
}

export async function apiFetch(input, init = {}) {
  // attach access token
  const { access } = getTokens();
  const headers = new Headers(init.headers || {});
  if (access) headers.set("Authorization", `Bearer ${access}`);

  let res = await fetch(input, { ...init, headers });

  if (res.status !== 401) return res;

  // Try once to refresh
  try {
    const newAccess = await refreshTokens();
    const retryHeaders = new Headers(init.headers || {});
    retryHeaders.set("Authorization", `Bearer ${newAccess}`);
    res = await fetch(input, { ...init, headers: retryHeaders });
    return res;
  } catch (e) {
    clearTokens();
    return res; // let caller handle 401 -> redirect to login
  }
}
